import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs"
import Hero from "../../components/Hero/Hero";
import SEO from "../../components/SEO/SEO"
import useIsMobile from "../../hooks/useIsMobile";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import Search from "./components/Search/Search";
import { useCallback, useEffect, } from "react";
import { getDatasetCount, getFilterOptions, getIndicators } from "../../redux/slices/openData/openDataThunk";
import Pagination from "../../components/Pagination/Pagination";
import ResponsiveContainer from "../../layouts/ResponsiveContainer";
import { LIMIT_PAGINATION_OPEN_DATA } from "../../utils/const";
import dataset from '../../assets/img/dataset.png'
import OpenDataIndicators from "./components/Indicators/OpenDataIndicators";
import { clearFilters, clearSelections } from "../../redux/slices/openData/openDataFiltersSlice";
import Filters from "./components/Filters/Filters";
import useUrlParams from "../../hooks/useUrlParams";
import { useUrlFiltersInitialization } from "../../hooks/useUrlFiltersInitialization";
import { store } from "../../redux/store";
import ContactSection from "../../components/Common/ContactSection";
import Loading from "../../components/Loading/Loading";

const DatasetCard = ({ countDataset }: { countDataset: number }) => {
    return (
        <div className="bg-primary-100 rounded-md border border-system-light-20 w-[16.625rem] h-[9.875rem]">
            <div className="p-4 flex flex-col justify-center items-center">
                <img src={dataset} alt="Dataset" className="w-[3.5rem] h-[2.625rem]" />
                <h3 className="text-brand-green-20 text-hlarge">Datasets</h3>
                <h3 className="text-brand-orange-10 text-dsmall">{countDataset}</h3>
            </div>
        </div>
    )
}

const Index = () => {
    const dispatch = useAppDispatch();
    const { indicators, pagination, loading, count_dataset } = useAppSelector((state) => state.open_data);
    const { filterOptions } = useAppSelector((state) => state.open_data_filters);
    const isMobile = useIsMobile();
    const { getParam, getMultipleParams, updateParams } = useUrlParams();

    useEffect(() => {
        if (!filterOptions) {
            dispatch(getFilterOptions());
        }
    }, [filterOptions, dispatch]);

    useEffect(() => {
        if (!count_dataset) {
            dispatch(getDatasetCount());
        }
    }, [count_dataset, dispatch]);

    useUrlFiltersInitialization();

    useEffect(() => {
        return () => {
            localStorage.removeItem("open_data_total_count");
            dispatch(clearFilters());
        };
    }, [dispatch]);

    const handlePageChange = useCallback((page: number) => {
        updateParams({ page: page.toString() });

        const typeIndicator = getMultipleParams('type');
        const derechos = getMultipleParams('derechos');
        const ods = getMultipleParams('ods');
        const gruposPrioritarios = getMultipleParams('priorityGroups');
        const variables = getMultipleParams('variables');

        dispatch(getIndicators({
            indicatorId: getParam('indicatorId') || '',
            typeIndicator: typeIndicator.length > 0 ? typeIndicator : undefined,
            page,
            limit: parseInt(getParam('limit') || LIMIT_PAGINATION_OPEN_DATA.toString(), 10),
            derechos: derechos.length > 0 ? derechos : undefined,
            ods: ods.length > 0 ? ods : undefined,
            gruposPrioritarios: gruposPrioritarios.length > 0 ? gruposPrioritarios : undefined,
            variables: variables.length > 0 ? variables : undefined
        }));

        const isAllSelected = store.getState().open_data_filters.isAllSelected;
        if (!isAllSelected) {
            dispatch(clearSelections());
        }
    }, [dispatch, updateParams, getMultipleParams, getParam]);

    return (
        <>
            <SEO
                title="Datos abiertos"
                description="Datos abiertos"
                type="article"
            />
            <Hero
                breadcrumbs={<Breadcrumbs />}
                title="Datos abiertos"
                paragraph="Bases de datos en formato abierto y reutilizable de todos los indicadores disponibles."
                layout="row"
                backgroundClassName={{ backgroundColor: '#E3DDD8' }}
                media={{ type: "", src: "", url: "", alt: "", className: "", }}
                expandableDescription={isMobile ? true : false}
                buttonExpandableDescriptionClassName="md:hidden"
                containerHeightClassName="h-[36rem] sm:h-[34.675rem] lg:h-[25rem] xl:h-[26rem]"
                customMedia={<DatasetCard countDataset={count_dataset ?? 0} />}
                contentContainerClassName='lg:items-center flex-col lg:flex-row'
                titleClassName='text-brand-green-20'
            />
            <div className='relative mt-6 flex justify-center items-center flex-col'>
                <Search />
                <ResponsiveContainer>
                    <div className="flex justify-between mt-12">
                        <h3 className="text-system-light-40 text-hmedium">Resultados</h3>
                        <span className="text-hsmall text-system-light-50">({loading ? 0 : pagination.totalItems})</span>
                    </div>
                    <div className="lg:flex items-start gap-5 w-full mt-12" id='open-data'>
                        <Filters />
                        {loading ? (
                            <Loading size={40} />
                        ) : (
                            <div className="w-full">
                                {indicators.length > 0 ? (
                                    <div id='indicator-cards'>
                                        <OpenDataIndicators indicators={indicators} />
                                        <Pagination
                                            data={indicators}
                                            totalPages={pagination.totalPages}
                                            currentPage={pagination.currentPage}
                                            setCurrentPage={handlePageChange}
                                            scrollTargetId='indicator-cards'
                                        />
                                    </div>
                                ) : (
                                    <h4 className="text-brand-green-20 text-center mt-8">No se encontraron indicadores.</h4>
                                )}
                            </div>
                        )}
                    </div>
                </ResponsiveContainer>
            </div>
            <ContactSection />
        </>
    )
}

export default Index